<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<!-- <button *ngIf = "showCloseButton" mat-icon-button [mat-dialog-close]="true" style="float:right;top:-20px;">
Close <i class="pi pi-times" aria-hidden="true"></i>
</button> -->


<div class="tabletopheader">
  <div class="topinfo d-flex align-items-center">
    <div class="col-lg-2">
      <h2 class="m-0" style="font-size: 26px;"> {{formTitle}}</h2>
    </div>
    <div class="col-lg-8 text-center">
      <span style="font-size: 16px;"><b>{{reservation?.guestProfile?.lastName}}</b>&nbsp;&nbsp;
      {{reservation?.shortTermRental?.propertyCode}}&nbsp;&nbsp;
      {{reservation?.checkInDate | date:'EEE MM/d'}} -
      {{reservation?.checkOutDate | date :'EEE MM/d'}}&nbsp;&nbsp;
      {{reservation?.numNights}}nts&nbsp;&nbsp;
      {{reservation?.numAdults}} adults&nbsp;&nbsp;
      {{reservation?.numChildren}} children
    </span>
  </div>
  <div class="col-lg-2 text-right">
    <button mat-icon-button (click)="closePopUp()" class="close-btn" [mat-dialog-close]="true" style="float:right;background-color: transparent;">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  </div>
</div>
<!-- <p-tabView [(activeIndex)]="tabIndex">
<p-tabPanel header="Task 5">
  <div class="grid">
    <span class="col">
      <h2 class="mt-2">Task 5</h2>
    </span>

    <span class=" col flex justify-content-end align-items-center mt-4">
      <span class="p-float-label ml-3">

      </span>
    </span>
  </div>
  <div class="p-4">
    PUT RAHUL TASK 5 COMPONENT HERE
  </div>
</p-tabPanel>

<p-tabPanel header="Admin">
  <div class="grid">
    <span class="col">
      <h2 class="mt-2">Admin</h2>
    </span>

    <span class=" col flex justify-content-end align-items-center mt-4">
      <span class="p-float-label ml-3">
      </span>
    </span>
  </div>
  <div class="p-4">
    <h2>Guest Moves</h2>
    <app-guest-move-list [orderId]=reservation?.order?.orderId [reservationId]=reservation?.reservationId></app-guest-move-list>
  </div>
</p-tabPanel>

<p-tabPanel header="Access">
  <div class="grid">
    <span class="col">
      <h2 class="mt-2">Access</h2>
    </span>

    <span class=" col flex justify-content-end align-items-center mt-4">
      <button pButton type="button" icon="pi pi-plus" label="Create Reservation" class="p-button-text"
      [routerLink]="['/homeowner-reservation']"></button>
      <span class="p-float-label ml-3">

      </span>
    </span>
  </div>

  <div class="p-4">
    <app-reservations></app-reservations>
  </div>
</p-tabPanel>
<p-tabPanel header="Housekeeping">
  Content 3
</p-tabPanel>

<p-tabPanel header="Maint">
  Content 3
</p-tabPanel>
<p-tabPanel header="Settings">
  <div class="grid">
    <span class="col">
      <h2 class="mt-2">Property Settings</h2>
    </span>

    <span class=" col flex justify-content-end align-items-center mt-4">
      <span class="p-float-label ml-3">

      </span>
    </span>
  </div>
  <app-property-profile></app-property-profile>
</p-tabPanel>
</p-tabView> -->

<div class="edit-order">
  <div class="container-fluid">
    <!-- <div class="col-lg-12">
    <div class="title">
      <h1 class="text-black fw-bold">
        Edit Order
      </h1>
    </div>
  </div> -->
  <!--<div class="col-lg-12">
  <div class="ads text-center mb-3">
    <img src="../../../../../assets/img/kbm-summer-sale.jpg" class="img-fluid">
  </div>
</div>-->

<p-tabView>
  <p-tabPanel header="Reservation">
    <app-reservation [reservation]="reservation"></app-reservation>
  </p-tabPanel>
  <p-tabPanel header="Housekeeping">
    <p>Housekeeping Content.</p>
  </p-tabPanel>
  <p-tabPanel header="Maintenance">
    <p>Maintenance Content.</p>
  </p-tabPanel>
  <p-tabPanel header="Admin">

    <ng-template pTemplate="content">
      <app-lostFound-list [reservationId]="reservationId"></app-lostFound-list>
      <app-guest-move-list [reservationId]="reservationId"></app-guest-move-list>
      <app-review-list [shortTermRentalId]="shortTermRentalId" [propertyCode]="propertyCode"></app-review-list>
      <app-guest-refund-list [reservationId]="reservationId"></app-guest-refund-list>
      <app-note-list [noteSource]="2" [noteSourceId]="reservationId"></app-note-list>
    </ng-template>
  </p-tabPanel>
</p-tabView>
</div>
</div>